export function getOrCreateUserUUID() {
    let uuid = getCookie('user_uuid') || localStorage.getItem('user_uuid');
    if (!uuid) {
        uuid = crypto.randomUUID();
        setCookie('user_uuid', uuid, 365); // store for 365 days
        localStorage.setItem('user_uuid', uuid);
    }
    else if (!getCookie('user_uuid')) {
        setCookie('user_uuid', uuid, 365);
    }
    else if (!localStorage.getItem('user_uuid')) {
        localStorage.setItem('user_uuid', uuid);
    }
    return uuid;
}
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
}
function setCookie(name, value, days) {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=None; Secure`;
}
